import React from 'react';
import Transition from 'react-transition-group/Transition';

const SectionFade = ({
  active,
  timeout,
  timing,
  children,
  onExited,
}) => {
  const defaultStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    transition: `opacity ${timing}ms ease-in-out, visibility ${timing}ms ease-in-out`,
    display: 'flex',
    flexDirection: 'column',
  };

  const transitionStyles = {
    entering: { opacity: 0, visibility: 'hidden' },
    entered:  { opacity: 1, visibility: 'visible' },
    exited: { opacity: 0, visibility: 'hidden' },
  };

  return (
    <Transition
      in={active}
      timeout={timeout}
      onExited={onExited}
    >
      {(state) => {
        return (
          <section style={{...defaultStyle, ...transitionStyles[state]}}>
            {children}
          </section>
        )
      }}
    </Transition>
  );
};

export default SectionFade;


// WEBPACK FOOTER //
// ./src/app/intro/components/SectionFade/SectionFade.js